"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.postToSapi = postToSapi;
var _UrlHelper = _interopRequireDefault(require("../utilities/UrlHelper"));
/**
 * Adds domain to cart via SAPI POST.
 *
 * @method postToSapi
 * @param {Object} params params object
 * @param {string} params.apiKey api key for request
 * @param {string} params.basketId guid for cart basket
 * @param {string|number} params.plid private label id
 * @param {string} params.itemTrackingCode item tracking code
 * @param {string} params.fqdn fully qualified domain name
 * @param {number} params.numberOfTerms monthly terms
 * @param {string} urlOverride override url like dev-godaddy.com, test-godaddy.com
 * @returns {Object} promise
 */
function postToSapi(params, urlOverride) {
  const {
    sapiCartPackages
  } = _UrlHelper.default.domainServices({
    apiKey: params.apiKey,
    plid: params.plid
  }, urlOverride);
  const requestData = {
    itc: params.itemTrackingCode,
    packages: [{
      pkgid: 'domain',
      domain: {
        name: `${params.fqdn}`
      },
      term: {
        termType: 'MONTH',
        NumberOfTerms: params.numberOfTerms || 12
      }
    }]
  };
  const extraParams = params.basketId ? {
    basketId: params.basketId
  } : {};
  const options = {
    method: 'POST',
    body: JSON.stringify(requestData),
    headers: {
      'Content-Type': 'application/json'
    }
  };
  return sapiCartPackages({
    packageId: '',
    options,
    extraParams
  }).then(response => {
    return Promise.resolve(response);
  }).catch(response => {
    return Promise.reject(response);
  });
}